import ApolloClient, { Operation } from 'apollo-boost';
import { getCookie } from '../utiles/utiles';
import { ENUM_HOST, ENUM_COOKIE_NAME } from '../enum/API';

//#region 그래프ql을 사용하기 위한 client 객체
const client: ApolloClient<unknown> = new ApolloClient({
    uri: process.env.API_ENV === 'prod' ? ENUM_HOST.PUBSUB_PROD : ENUM_HOST.PUBSUB_DEV,
    request: (operation: Operation) => {
        operation.setContext({
            headers: {
                authorization: `Bearer ${getCookie(ENUM_COOKIE_NAME.AUTH)}`,
                cno: getCookie(ENUM_COOKIE_NAME.CNO),
            },
        });
    },
});
//#endregion

export default client;
